<template>
  <div class="page-content receipts">
    <div class="row">
      <div class="col-12">
        <service-accounts-table
          :page-id="pageId"
          :show-actions="true"
          title="All Service Accounts"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { nextTick, onMounted } from 'vue';
import { useRoute } from 'vue-router';

import util from '@/Utils/util';

import ServiceAccountsTable from './ServiceAccounts/ServiceAccountsTable.vue';

const pageId = 'all-service-accounts';

export default {
  name: 'ServiceAccountManagement',

  components: {
    ServiceAccountsTable,
  },

  setup: () => {
    onMounted(async () => {
      const route = useRoute();
      const { hash } = route;

      await nextTick();
      util.moveScrollComponent(hash);
    });

    return {
      pageId,
    };
  },
};
</script>
